import React from 'react';
import { CustomIconProps, setColor } from '..';

const ArtifactsIcon: React.FunctionComponent<CustomIconProps> = props => {
  const iconColor = setColor(props);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
      <g id="Simple" transform="translate(-200 -376)">
        <rect
          id="Rectangle_3715"
          data-name="Rectangle 3715"
          width="10"
          height="2"
          rx="1"
          transform="translate(200 384)"
          fill={iconColor}
        />
        <rect
          id="Rectangle_3716"
          data-name="Rectangle 3716"
          width="10"
          height="2"
          rx="1"
          transform="translate(200 380)"
          fill={iconColor}
          opacity="0.25"
        />
        <rect
          id="Rectangle_3717"
          data-name="Rectangle 3717"
          width="10"
          height="2"
          rx="1"
          transform="translate(200 376)"
          fill={iconColor}
          opacity="0.25"
        />
      </g>
    </svg>
  );
};
export default ArtifactsIcon;
